import { CommonModule } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    Input,
    Output
} from "@angular/core";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { DeviceService } from "@app/shared/services/device.service";

@Component({
    selector: "app-chat-message",
    imports: [SharedDsnModule, SharedMaterialModule, CommonModule],
    templateUrl: "./chat-message.component.html",
    styleUrl: "./chat-message.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatMessageComponent {
    @Input() message: string;
    @Input() date?: string;
    @Input({ required: true }) postUserId: string;
    @Input() userName: string;
    @Input({ required: true }) userId: string;
    @Input() avatar?: string;
    @Input() initials?: string;
    @Input() showDelete?: boolean = false;
    @Output() onDelete = new EventEmitter<void>();

    @Input({ required: false })
    public isMobileComment: boolean = false;

    private readonly deviceService = inject(DeviceService);
    public isMobile = this.deviceService.getIsMobile();

    public handleDelete(): void {
        this.onDelete.emit();
    }
}
